/* DVR - VESTUARIO ABRE AS MODALIDADES NO MENU LATERAL. (Claude, 28/09/2026)

   Pedido do Fredy, na letra dele: "acrescente aqui no menu lateral tambem,
   para quando clicar no vestuario ja aparecer ali as opcoes de unissex,
   oversized e baby look, porque a pessoa pode nao enxergar quando entrar na
   pagina de vestuario". E o mesmo diagnostico dele de antes: quem chega nao
   sabe que existe um seletor de modelagem. Se a categoria abre as opcoes no
   menu, a pessoa descobre antes de entrar.

   E depois: "como a pessoa ja esta no vestuario, sera que e possivel, quando
   ela clicar no menu lateral, o vestuario ja aparecer aceso, como se mostrasse
   tipo voce esta aqui?". Da, e esta na segunda metade do arquivo.

   POR QUE AQUI E NAO NA NAVEGACAO DA LOJA. O certo seria pendurar os quatro
   filhos em Navegacao > Linhas: o tema desenha o "+" sozinho, com a animacao
   e o acessivel dele. Duas coisas me fizeram desviar.

   1. A Navegacao e da LOJA, nao do tema. Ela vale na hora para o tema
      publicado, que hoje e a v44. A v44 nao carrega o dvr-loja.js, que e quem
      le o ?mod= da URL: os tres links cairiam todos na colecao inteira, sem
      filtro. Seria meia funcao no ar antes de ele publicar.
   2. A API de menu da Shopify nao acrescenta item: ela substitui o menu
      inteiro. Os 45 itens de Linhas seriam apagados e recriados com id novo
      para eu poder incluir quatro. Troca ruim.

   Aqui e camada: existe so na v45, aparece no segundo em que ele publicar, e
   apagar este arquivo desfaz. Nenhum item de menu e tocado.

   O QUE ESTE ARQUIVO FAZ. O tema ja desenha o acordeao para toda categoria
   com filhos (Gotas, Gourmet, Pet...). Vestuario, sem filhos, sai como link
   simples. Entao aqui o link simples e trocado pelo MESMO markup que o tema
   usa nos outros: accordion-custom, details, summary com o icone de mais, e a
   lista de filhos. Nao e imitacao de estilo, e a mesma marcacao, copiada do
   snippets/header-drawer.liquid. Como accordion-custom e custom element, ele
   se liga sozinho ao entrar no DOM, com a animacao e o comportamento do tema.

   Se um dia os filhos forem para a Navegacao de verdade, este arquivo sai de
   cena sozinho: ele desiste quando ja encontra um acordeao no Vestuario.
*/
(function () {
'use strict';

/* DVR 28/09/2026 - OS OVERSIZED ENTRARAM NO AR, E OS NUMEROS SAIRAM DAQUI.
   O rotulo dizia "Oversized · em breve" e o pai dizia "79 estampas". Os dois
   viraram mentira no dia em que o Fredy ativou os produtos: a oversized ja
   vende e a unissex hoje tem 80. Numero escrito na mao dentro de um arquivo e
   promessa de ficar velho, e quem le no menu nao tem como desconfiar. Como a
   propria vitrine imprime a contagem certa a cada carregamento, logo abaixo,
   preferi tirar os numeros daqui a trocar um numero velho por outro.

   DVR 01/10/2026 - OS NOMES CRESCERAM. Fredy: "so unissex fica meio amplo",
   e quem procura peca feminina nao reconhece "baby look" como resposta a
   busca dela. Nao criei um item "Feminina" separado de proposito: ele levaria
   ao MESMO lugar que a baby look, porque baby look ja e o corte feminino, e
   duas portas para a mesma sala confundem. As duas palavras foram para o
   mesmo rotulo.
   O espaco entre "baby" e "look" e DURO ( ) de proposito: sem ele a
   quebra de linha caia no meio do parenteses e saia "(baby" em cima com
   "look)" embaixo. */
/* DVR 22/10/2026 - CADA MODELAGEM TEM A SUA PAGINA. Desde hoje unissex,
   baby look e oversized sao tres colecoes de verdade (/collections/vestuario,
   /collections/camisetas-baby-look e /collections/camisetas-oversized). O
   ?mod= deixou de ser o caminho: so gravava a modelagem no navegador e deixava
   todo mundo na mesma pagina. A modalidade() agora le o CAMINHO primeiro. */
var FILHOS = [
  { rotulo: 'Toda a coleção',                 url: '/collections/vestuario', chave: 'todas' },
  { rotulo: 'Camiseta unissex',               url: '/collections/vestuario', chave: 'uni' },
  { rotulo: 'Camiseta feminina (baby look)', url: '/collections/camisetas-baby-look', chave: 'bab' },
  { rotulo: 'Camiseta oversized',             url: '/collections/camisetas-oversized', chave: 'ove' }
];

/* as colecoes de estilo sao Vestuario tambem: quem esta em Botanico esta
   dentro da linha, e o menu tem que dizer isso */
var ESTILOS = ['botanico', 'magico', 'mistico', 'animais', 'fofinhos', 'retro'];

var OURO = '#d4b36a';

var MAIS =
  '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"></path>' +
  '<path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"></path>' +
  '</svg>';

/* ---------- A FAIXA BRANCA NA PRIMEIRA ABERTURA DO MEGA MENU ----------
   DVR 28/09/2026. Fredy: "sempre a primeira passada de mouse a barra se
   estende com esse adicional branco alem dos produtos".

   Os seis paineis do mega menu tem content-visibility:auto com
   contain-intrinsic-size: auto 0px auto 500px. Enquanto o painel nunca foi
   aberto o navegador nao renderiza o conteudo e RESERVA 500px no lugar. Na
   primeira passada de mouse ele renderiza de verdade, e naquele quadro a
   reserva aparece como faixa clara por cima da pagina. Depois o tamanho real
   fica guardado e nunca mais acontece, que e o "so na primeira" dele.

   POR QUE ESTA AQUI E NAO NO dvr-loja.css. Eu tinha posto a regra la, e ela
   funcionava na pagina da colecao e continuava quebrada na home. O motivo e
   simples e eu devia ter conferido antes: aquele arquivo so e carregado nas
   paginas do vestuario, e o menu do topo e de toda a loja. Medi na home com a
   correcao ja no tema: os seis paineis reportavam 501px de altura, que e a
   reserva de 500. Este arquivo carrega em toda pagina, entao e o lugar certo.
   A regra continua escrita tambem na secao 7 do dvr-loja.css; quem resolve de
   verdade e esta.

   Injeto antes de qualquer outra coisa e fora do try do resto: se a troca do
   menu lateral falhar, o conserto da faixa nao vai junto. */
function semFaixa() {
  if (document.getElementById('dvr-menu-cv')) return;
  var e = document.createElement('style');
  e.id = 'dvr-menu-cv';
  e.textContent = '.menu-list__submenu{content-visibility:visible !important;' +
                  'contain-intrinsic-size:auto !important}';
  (document.head || document.documentElement).appendChild(e);
}
try { semFaixa(); } catch (e) {}

function sem(s) {
  return (s || '').toString().toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
}
function escapa(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function caminho() {
  return (location.pathname || '').replace(/\/+$/, '');
}

/* ---------- VOCE ESTA AQUI ----------
   O tema JA escreve menu-drawer__menu-item--active e aria-current no item da
   pagina em que a pessoa esta: conferi no HTML servido e o Vestuario chega
   marcado quando se esta na colecao. O que ele NAO faz e dar aparencia a essa
   classe. Medi as duas: cor, peso, sublinhado, opacidade e fundo saem iguais
   com e sem ela. Ou seja, a marca existia so para leitor de tela, e ninguem
   via nada. Entao o estilo entra aqui.

   E tinha um estrago meu junto: ao trocar o link pelo acordeao, eu jogava fora
   a classe que o tema havia escrito. Agora ela e lida do link antes e vai para
   o summary. */
function estilo() {
  if (document.getElementById('dvr-menu-css')) return;
  var e = document.createElement('style');
  e.id = 'dvr-menu-css';
  e.textContent =
    '.menu-drawer .dvr-aqui,' +
    '.menu-drawer .dvr-aqui:hover,' +
    '.menu-drawer .dvr-aqui .menu-drawer__menu-item-text{ color:' + OURO + ' !important; }' +
    /* a bolinha diz "e este" sem precisar da palavra, e e o mesmo ouro do
       sublinhado da barra de modalidade, entao a pessoa ve o mesmo sinal nos
       dois lugares */
    '.menu-drawer a.dvr-aqui .menu-drawer__menu-item-text::before{' +
      'content:""; display:inline-block; width:5px; height:5px;' +
      'border-radius:50%; background:' + OURO + ';' +
      'margin-inline-end:7px; vertical-align:middle;' +
    '}' +
    /* DVR 01/10/2026 - A LISTA FILHA DO VESTUARIO EM UMA COLUNA.
       Fredy mandou o print: "aqui eu deixaria maior tipo para dar para
       enxergar com mais facilidade". O tema desenha toda lista filha como
       grade de seis colunas de 64 px, com letra de 8 px em caixa alta. Isso
       serve para as Gotas, que tem rotulo de uma palavra; com "Camiseta
       feminina (baby look)" dentro de 64 px o navegador hifenizava no meio da
       palavra. So a lista do Vestuario muda, pelo id proprio dela: as outras
       categorias continuam exatamente como o tema desenha. */
    '#Details-menu-drawer-vestuario .menu-drawer__menu--childlist{' +
      'grid-template-columns:1fr !important; gap:0 !important;' +
    '}' +
    '#Details-menu-drawer-vestuario .menu-drawer__menu-item--child{' +
      'font-size:13px !important; text-transform:none !important;' +
      'letter-spacing:0 !important; line-height:1.3 !important;' +
      'hyphens:none !important; padding-block:8px !important;' +
    '}';
  document.head.appendChild(e);
}

/* a modalidade que a vitrine esta mostrando. A URL manda, porque e o link que
   a pessoa acabou de clicar; depois a chave que a propria barra usa. */
function modalidade() {
  /* 22/10/2026: o caminho manda antes do ?mod= e do localStorage */
  var c = caminho();
  if (c === '/collections/camisetas-baby-look') return 'bab';
  if (c === '/collections/camisetas-oversized') return 'ove';
  if (c === '/collections/vestuario') return 'uni';
  var m = (location.search.match(/[?&]mod=([a-z]+)/i) || [])[1];
  if (m) return m.toLowerCase();
  try {
    var a = JSON.parse(localStorage.getItem('dvr:vitrine2') || '{}');
    if (a && a.mod) return String(a.mod).toLowerCase();
  } catch (e) {}
  return 'uni';
}

/* as tres paginas de modelagem (22/10/2026) */
function paginaDaLinha() {
  var c = caminho();
  return c === '/collections/vestuario' ||
         c === '/collections/camisetas-baby-look' ||
         c === '/collections/camisetas-oversized';
}

function naVitrine() {
  if (paginaDaLinha()) return true;
  return !!(window.DVR_AQUI && ESTILOS.indexOf(String(window.DVR_AQUI)) >= 0);
}

/* esta dentro do Vestuario? o acordeao ja abre aberto quando sim */
function dentro(a) {
  if (a && /menu-drawer__menu-item--active/.test(a.className || '')) return true;
  if (naVitrine()) return true;
  if (caminho().indexOf('/products/oversized-') === 0) return true;
  /* pagina de produto da linha: a secao imprime a configuracao em .vf-cfg */
  return !!document.querySelector('.vf-cfg');
}

/* qual filho recebe a marca. So marco onde nao tem como errar: na colecao
   inteira, o filho da modalidade que a vitrine esta mostrando; na pagina de um
   oversized, o Oversized. Em Botanico e em pagina de camiseta o pai fica aceso
   e nenhum filho, porque nenhum dos quatro descreve aquela tela. */
function filhoAqui() {
  if (caminho().indexOf('/products/oversized-') === 0) return 'ove';
  if (!paginaDaLinha()) return null;
  var m = modalidade();
  return (m === 'uni' || m === 'bab' || m === 'ove') ? m : null;
}

function monta(titulo, aceso, filho) {
  var s = '';
  s += '<accordion-custom' + (aceso ? ' open-by-default-on-mobile open-by-default-on-desktop' : '') + '>';
  s += '<details id="Details-menu-drawer-vestuario">';
  s += '<summary id="HeaderDrawer-vestuario" class="menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset' +
       (aceso ? ' menu-drawer__menu-item--active dvr-aqui' : '') + '"' +
       (aceso ? ' aria-current="page"' : '') + '>';
  s += '<span class="menu-drawer__menu-item-text wrap-text">' + escapa(titulo) + '</span>';
  s += '<span class="svg-wrapper icon-plus">' + MAIS + '</span>';
  s += '</summary>';
  s += '<ul class="menu-drawer__menu menu-drawer__menu--childlist menu-drawer__animated-element details-content" role="list" tabindex="-1">';
  for (var i = 0; i < FILHOS.length; i++) {
    var f = FILHOS[i], eu = (filho && f.chave === filho);
    s += '<li class="menu-drawer__list-item" style="--menu-drawer-animation-index: ' + (i + 1) + ';">';
    s += '<a id="HeaderDrawer-vestuario-' + f.chave + '" href="' + escapa(f.url) + '"' +
         ' class="menu-drawer__menu-item menu-drawer__menu-item--child focus-inset' +
         (eu ? ' menu-drawer__menu-item--active dvr-aqui' : '') + '"' +
         (eu ? ' aria-current="page"' : '') + '>';
    s += '<span class="menu-drawer__menu-item-text wrap-text">' + escapa(f.rotulo) + '</span>';
    s += '</a></li>';
  }
  s += '</ul></details></accordion-custom>';
  return s;
}

function troca() {
  var listas = document.querySelectorAll('nav.menu-drawer__navigation > ul');
  for (var i = 0; i < listas.length; i++) {
    var itens = listas[i].children;
    for (var j = 0; j < itens.length; j++) {
      var li = itens[j];
      if (li.getAttribute('data-dvr-mods')) continue;
      var a = li.querySelector(':scope > a.menu-drawer__menu-item--mainlist');
      if (!a) continue;
      var t = a.querySelector('.menu-drawer__menu-item-text');
      if (sem(t ? t.textContent : a.textContent) !== 'vestuario') continue;
      /* se um dia os filhos vierem da Navegacao, o tema ja desenha o acordeao
         e este arquivo nao tem nada a fazer alem do estilo do aceso */
      if (li.querySelector('accordion-custom, details')) { li.setAttribute('data-dvr-mods', 'nativo'); continue; }
      li.setAttribute('data-dvr-mods', '1');
      estilo();
      var titulo = (t ? t.textContent : a.textContent).trim();
      a.insertAdjacentHTML('afterend', monta(titulo, dentro(a), filhoAqui()));
      a.parentNode.removeChild(a);
    }
  }
}

/* ---------- QUANDO RODAR ----------
   A gaveta e redesenhada depois do carregamento: o proprio snippet do tema
   avisa que renderiza duas vezes, "the second render then refreshes the page
   with additional content". Na pagina de produto eu vi o resultado disso: a
   troca acontecia e depois voltava o link simples, e o observador de DOM nao
   reagia a tempo.

   Em vez de investigar o redesenho do tema por dentro, que nao e meu e pode
   mudar, eu rodo de novo em momentos fixos, que e o mesmo remedio que o
   vf-molde.js do tema usa para o mesmo problema. Converter e barato e
   idempotente: o data-dvr-mods segura o trabalho repetido.

   A ordem tambem mudou de proposito. O observador e registrado ANTES da
   primeira tentativa. Do jeito antigo, se a primeira chamada estourasse no
   meio, o registro do observador ficava para tras e o arquivo morria calado.
   Por isso as chamadas tambem vao dentro de try. */
function tenta() {
  try { troca(); } catch (e) {}
}

if (window.MutationObserver) {
  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(tenta, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tenta);
else tenta();
window.addEventListener('load', tenta);
setTimeout(tenta, 400);
setTimeout(tenta, 1200);
setTimeout(tenta, 2500);
/* volta do cache de historico (botao voltar) com a gaveta do jeito do tema */
window.addEventListener('pageshow', tenta);
})();